import { useTranslation } from "react-i18next";
import { Linkedin, Quote } from "lucide-react";
import ostapPhoto from "@/assets/ostap-dribniuk.png";

export function SuiteTestimonial() {
  const { t } = useTranslation();

  return (
    <div className="relative rounded-2xl border border-border/50 bg-muted/30 p-6 md:p-8">
      <Quote className="absolute top-5 left-5 h-7 w-7 text-primary/15" />
      <blockquote className="relative z-10">
        <p className="text-base md:text-lg text-foreground leading-relaxed italic mb-4">
          "{t("suiteTestimonial.quote")}"
        </p>
        <footer className="flex items-center gap-3">
          <img
            src={ostapPhoto}
            alt={t("suiteTestimonial.name")}
            width={128}
            height={128}
            loading="lazy"
            decoding="async"
            className="h-10 w-10 rounded-full object-cover"
          />
          <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-2">
            <span className="font-semibold text-sm text-foreground">{t("suiteTestimonial.name")}</span>
            <span className="hidden sm:inline text-muted-foreground">·</span>
            <span className="text-xs text-muted-foreground">{t("suiteTestimonial.role")}</span>
          </div>
          <a
            href="https://www.linkedin.com/in/ostap-dribniuk/"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-auto shrink-0 text-muted-foreground hover:text-primary transition-colors"
            aria-label="Ostap Dribniuk on LinkedIn"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </footer>
      </blockquote>
    </div>
  );
}
